//sepori-services/packages/shared/src/abis.ts
// Slipstream pool (Uniswap V3-style) — matches your file: no feeProtocol in slot0
export const slipstreamPoolAbi = [
    {
        inputs: [],
        name: "slot0",
        outputs: [
            { name: "sqrtPriceX96", type: "uint160" },
            { name: "tick", type: "int24" },
            { name: "observationIndex", type: "uint16" },
            { name: "observationCardinality", type: "uint16" },
            { name: "observationCardinalityNext", type: "uint16" },
            { name: "unlocked", type: "bool" },
        ],
        stateMutability: "view",
        type: "function",
    },
    { inputs: [], name: "token0", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "token1", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "fee", outputs: [{ type: "uint24" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "tickSpacing", outputs: [{ type: "int24" }], stateMutability: "view", type: "function" },
];
export const erc20Abi = [
    { inputs: [], name: "decimals", outputs: [{ type: "uint8" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "symbol", outputs: [{ type: "string" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "totalSupply", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "balanceOf", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
];
// Uniswap V2-style pair abi (getReserves/token addresses)
export const v2PairAbi = [
    {
        inputs: [],
        name: "getReserves",
        outputs: [
            { name: "reserve0", type: "uint112" },
            { name: "reserve1", type: "uint112" },
            { name: "blockTimestampLast", type: "uint32" }
        ],
        stateMutability: "view",
        type: "function"
    },
    { inputs: [], name: "token0", outputs: [{ name: "", type: "address" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "token1", outputs: [{ name: "", type: "address" }], stateMutability: "view", type: "function" }
];
// Basic/Solidly-style pool (adds read-only quoting for stables)
export const basicPoolAbi = [
    {
        inputs: [],
        name: "getReserves",
        outputs: [
            { name: "reserve0", type: "uint112" },
            { name: "reserve1", type: "uint112" },
            { name: "blockTimestampLast", type: "uint32" }
        ],
        stateMutability: "view",
        type: "function"
    },
    { inputs: [], name: "token0", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "token1", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "stable", outputs: [{ type: "bool" }], stateMutability: "view", type: "function" },
    {
        inputs: [
            { name: "amountIn", type: "uint256" },
            { name: "tokenIn", type: "address" }
        ],
        name: "getAmountOut",
        outputs: [{ type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
];
// Sugar ABI
export const sugarAbi = [
    {
        inputs: [{ internalType: "address", name: "_address", type: "address" }],
        name: "byAddress",
        outputs: [
            {
                components: [
                    { internalType: "address", name: "lp", type: "address" },
                    { internalType: "string", name: "symbol", type: "string" },
                    { internalType: "uint8", name: "decimals", type: "uint8" },
                    { internalType: "uint256", name: "liquidity", type: "uint256" },
                    { internalType: "int24", name: "type", type: "int24" },
                    { internalType: "int24", name: "tick", type: "int24" },
                    { internalType: "uint160", name: "sqrt_ratio", type: "uint160" },
                    { internalType: "address", name: "token0", type: "address" },
                    { internalType: "uint256", name: "reserve0", type: "uint256" },
                    { internalType: "uint256", name: "staked0", type: "uint256" },
                    { internalType: "address", name: "token1", type: "address" },
                    { internalType: "uint256", name: "reserve1", type: "uint256" },
                    { internalType: "uint256", name: "staked1", type: "uint256" },
                    { internalType: "address", name: "gauge", type: "address" },
                    { internalType: "uint256", name: "gauge_liquidity", type: "uint256" },
                    { internalType: "bool", name: "gauge_alive", type: "bool" },
                    { internalType: "address", name: "fee", type: "address" },
                    { internalType: "address", name: "bribe", type: "address" },
                    { internalType: "address", name: "factory", type: "address" },
                    { internalType: "uint256", name: "emissions", type: "uint256" },
                    { internalType: "address", name: "emissions_token", type: "address" },
                    { internalType: "uint256", name: "pool_fee", type: "uint256" },
                    { internalType: "uint256", name: "unstaked_fee", type: "uint256" },
                    { internalType: "uint256", name: "token0_fees", type: "uint256" },
                    { internalType: "uint256", name: "token1_fees", type: "uint256" },
                    { internalType: "address", name: "nfpm", type: "address" },
                    { internalType: "address", name: "alm", type: "address" },
                    { internalType: "address", name: "root", type: "address" },
                ],
                internalType: "struct Sugar.Lp",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export const SUGAR_ADDRESS = "0x01cba9e44ad356bad5e2d616357b69cb406248ac";
// Gauge ABI (for APR calculations and user rewards)
// Supports both basic gauges (balanceOf/earned) and slipstream gauges (deposited/rewards)
export const gaugeAbi = [
    { inputs: [], name: "rewardRate", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "token", type: "address" }], name: "rewardRate", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "periodFinish", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "token", type: "address" }], name: "periodFinish", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "totalSupply", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "rewardToken", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    // Basic gauge functions
    { inputs: [{ name: "account", type: "address" }], name: "balanceOf", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "earned", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    // Slipstream gauge functions (alternative names)
    { inputs: [{ name: "account", type: "address" }], name: "deposited", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "rewards", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "staked", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "pending", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "userBalance", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }], name: "userRewards", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
];
// Slipstream gauge ABI (NFT-based positions)
export const slipstreamGaugeAbi = [
    { inputs: [], name: "rewardRate", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "periodFinish", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "rewardToken", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    { inputs: [], name: "nft", outputs: [{ type: "address" }], stateMutability: "view", type: "function" },
    // NFT position functions
    { inputs: [{ name: "depositor", type: "address" }], name: "stakedLength", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "depositor", type: "address" }], name: "stakedValues", outputs: [{ type: "uint256[]" }], stateMutability: "view", type: "function" },
    { inputs: [{ name: "account", type: "address" }, { name: "tokenId", type: "uint256" }], name: "earned", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
];
// NonfungiblePositionManager ABI for NFT position details
export const nftPositionManagerAbi = [
    {
        inputs: [{ name: "tokenId", type: "uint256" }],
        name: "positions",
        outputs: [
            { name: "nonce", type: "uint96" },
            { name: "operator", type: "address" },
            { name: "token0", type: "address" },
            { name: "token1", type: "address" },
            { name: "fee", type: "uint24" },
            { name: "tickLower", type: "int24" },
            { name: "tickUpper", type: "int24" },
            { name: "liquidity", type: "uint128" },
            { name: "feeGrowthInside0LastX128", type: "uint256" },
            { name: "feeGrowthInside1LastX128", type: "uint256" },
            { name: "tokensOwed0", type: "uint128" },
            { name: "tokensOwed1", type: "uint128" }
        ],
        stateMutability: "view",
        type: "function"
    }
];
// NonfungiblePositionManager address for Aerodrome on Base
export const NPM_ADDRESS = "0x827922686190790b37229fd06084350E74485b72";
